import React, { useCallback } from "react";
import { useSetAtom } from "jotai";
import { useItemGroups } from "atoms/itemsGropAtom";
import {
  setConfirmationModalAtom,
  setInfoModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";
import { allItemGroups } from "constant-data/items";
import { AxiosError } from "axios";

import { Button } from "components/Button/Button";

import { useDeleteProductsGroup } from "../api";

export function DeleteButton() {
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const setInfoModal = useSetAtom(setInfoModalAtom);
  const closeModal = useSetAtom(setModalCloseAtom);
  const { itemGroupsState, setItemGroupsState } = useItemGroups();

  const { mutate: deleteProductsGroup } = useDeleteProductsGroup();

  const onConfirm = useCallback(() => {
    deleteProductsGroup(itemGroupsState.activeItemsGroup!.itemgroupid, {
      onSuccess: () => {
        setItemGroupsState({ activeItemsGroup: null });
      },
      // @ts-ignore
      onError: (e: AxiosError<{ message: string }>) => {
        if (e?.status === 400) {
          setInfoModal({ title: e?.response?.data.message || "" });
        }
      },
    });
    closeModal();
  }, [closeModal, itemGroupsState]);

  const handleOpenModal = useCallback(() => {
    if (itemGroupsState.activeItemsGroup) {
      setConfirmationModal({
        title: `Вы действительно хотите удалить группу "${itemGroupsState.activeItemsGroup.name}"?`,
        onConfirm,
      });
    }
  }, [itemGroupsState, setConfirmationModal, onConfirm]);

  return (
    <Button
      icon="delete"
      onClick={handleOpenModal}
      disabled={
        !itemGroupsState.activeItemsGroup ||
        itemGroupsState.activeItemsGroup.itemgroupid ===
          allItemGroups.itemgroupid
      }
    />
  );
}
